import { Observable } from 'rxjs';
import { AdvisorResponse, AdvisorSingularData } from '../../interfaces/advisor/advisor.interface';

export abstract class AdvisorRepository {

    abstract getAdvisorInformation(sessionId: string, BodyAdvisor: string): Observable<AdvisorSingularData>;

    abstract getAdvisorsList(sessionId: string): Observable<AdvisorResponse>;

}   